import React, { useEffect, useState } from "react";
import LeftBar from "../../../components/left-bar/LeftBar";
import NavigationLinks from "../../../components/navigation-links/NavigationLinks";
import {getMegafonMegalabsMessages, getMegafonMegalabsMessageTypes, navLinks,} from "../../../services/settings";import Content from "../../../components/content/Content";
import DataTable from "../../../components/data-table/DataTable";
import { useTranslation } from "react-i18next";
import ActionButton from "../../../components/button/ActionButton";
import DateField from "../../../components/fields/DateField";
import _ from "lodash";
import moment from "moment";
import XLSX from "xlsx";
import SelectFromItemsField from "../../../components/fields/SelectFromItemsField";

const columnData = [
    { id: "phoneNumber", label: "Phone" },
    { id: "textMessage", label: "Message" },
    { id: "typeMessage", label: "Type" },
    { id: "statusMessage", label: "Status" },
    { id: "amountOfSymbol", label: "Symbols count" },
    { id: "amountOfSms", label: "SMS count" },
    {id: "dateCreated", label: "Date send message", dateFormat: "DD.MM.YYYY HH:mm:ss" },
];

const columnDataXlsx = [
    { id: "phoneNumber", label: "Phone" },
    { id: "textMessage", label: "Message" },
    { id: "typeMessage", label: "Type" },
    { id: "statusMessage", label: "Status" },
    { id: "amountOfSymbol", label: "Symbols count" },
    { id: "amountOfSms", label: "SMS count" },
    {id: "dateCreated", label: "Date send message", dateFormat: "DD.MM.YYYY HH:mm:ss",},
];

export default function MegafonMegalabsPage() {
    const { t } = useTranslation();
    const loading = true;
    const [tableDataParameters, setTableDataParameters] = useState({
        filterDateStart: null,
        filterDateStop: null,
        typeMessage: null,
    });
    const [canGetData, setCanGetData] = useState(false);
    const [tableKey, setTableKey] = useState(0);
    const [shouldLoadData, setShouldLoadData] = useState(false);
    const [exportLoading, setExportLoading] = useState(false);

    const handleTableDataParametersDateChange = prop => date => {
        const newState = {
            ...tableDataParameters,
            [prop]: date,
        };

        setTableDataParameters(newState);
        setShouldLoadData(false);

        if (newState.filterDateStart && newState.filterDateStop) {
            setCanGetData(true);
        } else {
            setCanGetData(false);
        }
    };

    const [messageTypes, setMessageTypes] = useState([]);

    const handleTableDataParametersChange = event => {
        const newState = {
            ...tableDataParameters,
            [event.target.name]: event.target.value,
        };

        setTableDataParameters(newState);
        setShouldLoadData(false);

        if (newState.filterDateStart && newState.filterDateStop) {
            setCanGetData(true);
        } else {
            setCanGetData(false);
        }
    };
    const getTableData = (page, per_page, order) => {
        return getMegafonMegalabsMessages(
            page,
            per_page,
            order,
            "dateCreated",
            tableDataParameters
        );
    };

    const loadData = () => {
        setShouldLoadData(true);
        setTableKey(prev => prev + 1);
    };

    const handleExport = () => {
        setExportLoading(true);
        getMegafonMegalabsMessages(
            1,
            -1,
            "desc",
            "actualSendDate",
            tableDataParameters
        )
            .then(response => {
                if (!response.success) {
                    return;
                }

                const data = [columnDataXlsx.map(col => t(col.label))];
                response.data.forEach(row => {
                    data.push(
                        columnDataXlsx.map(col => {
                            let value = _.get(row, col.id);

                            if (col.dateFormat && value) {
                                return moment(value).format(col.dateFormat);
                            }

                            return value ?? "";
                        })
                    );
                });

                const worksheet = XLSX.utils.aoa_to_sheet(data);
                const workbook = XLSX.utils.book_new();

                XLSX.utils.book_append_sheet(
                    workbook,
                    worksheet,
                    "Megafon megalabs messages"
                );
                XLSX.writeFile(
                    workbook,
                    `megafon_megalabs_messages_${moment().format(
                        "YYYY_MM_DD_HH_mm"
                    )}.xlsx`
                );
            })
            .finally(() => {
                setExportLoading(false);
            });
    };

    useEffect(() => {
        getMegafonMegalabsMessageTypes().then(response => {
            setMessageTypes(response);
        });
    }, []);

    return (
        <>
            <LeftBar navigationLinks={<NavigationLinks links={navLinks} />}>
                <DateField
                    label={t("Period start")}
                    value={tableDataParameters.filterDateStart}
                    onChange={handleTableDataParametersDateChange(
                        "filterDateStart"
                    )}
                    fullWidth
                    disabled={!loading}
                />
                <DateField
                    label={t("Period end")}
                    value={tableDataParameters.filterDateStop}
                    onChange={handleTableDataParametersDateChange(
                        "filterDateStop"
                    )}
                    fullWidth
                    disabled={!loading}
                />
                <SelectFromItemsField
                    name="typeMessage"
                    label={t("Type")}
                    items={messageTypes}
                    value={tableDataParameters.typeMessage}
                    onChange={handleTableDataParametersChange}
                    valueField="id"
                    textField="text"
                    nullable
                    fullWidth
                />
                <ActionButton
                    disabled={!loading || !canGetData}
                    onClick={loadData}
                >
                    {t("Filter")}
                </ActionButton>
                <ActionButton
                    disabled={!loading || exportLoading || !canGetData}
                    onClick={handleExport}
                >
                    {t("Export to Excel")}
                </ActionButton>
            </LeftBar>
            <Content title={t("Megafon Messages")}>
                <DataTable
                    key={tableKey}
                    columnData={columnData}
                    dataFunc={
                        shouldLoadData
                            ? getTableData
                            : () => Promise.resolve({ data: [], total: 0 })
                    }
                    selector={false}
                />
            </Content>
        </>
    );
}